module.exports = __webpack_public_path__ + "img/acount_des_1.d2334741.jpg";